define(
    'models/user',[
        'settings'
    ],
    function (settings) {

        var User = (function() {
            /**
             * @class User
             * @constructor
             */
            function User() {
                if (this.isLoggedin()) {
                    this.username = settings.user.username;    
                }
            }

            User.prototype.isLoggedin = function() {
                return !!(settings.user);
            };

            User.prototype.getUserName = function() {
                return this.isLoggedin() ? this.username : false;
            };


            return User;
        })();
        
        return new User();
    }
);
